import { Box, SxProps } from '@mui/material';
import React, { FC, memo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Organization } from '../../../../api/api';
import { localized, localizedInterpolation } from '../../../../i18n/i18n';
import { AppState } from '../../../../state/store';
import { invalidColor } from '../../../../styles/color-constants';
import { nameof } from '../../../../utilities/platform-helpers/nameof-helper';
import { requiredValidator } from '../../../../utilities/platform-helpers/validator-helper';
import { TextInput } from '../../../components/default-components/form/text-input';
import { StyledButton } from '../../../components/specific-components/buttons/styled-button';
import { SidebarCancelButton } from '../../../components/specific-components/sidebar-cancel-button';
import { OrganizationDeleteButton } from './organization-form-delete-button';

const localStyles: { [key: string]: SxProps } = {
  inputLine: {
    marginTop: 1,
    marginBottom: 1,
  },
  deleteButton: {
    backgroundColor: invalidColor,
  },
};

interface PropsFromParent {
  existingOrganization?: Organization;
}

export const OrganizationForm: FC<PropsFromParent> = memo(({ existingOrganization }) => {
  const { pending } = useSelector((store: AppState) => store.organizationReducer);
  const { reset, resetField } = useFormContext();

  useEffect(() => {
    reset({
      ...existingOrganization,
      name: existingOrganization?.name,
      description: existingOrganization?.description,
    });
  }, [existingOrganization, reset, resetField]);

  return (
    <>
      <h1>
        {localizedInterpolation(existingOrganization ? 'EditInt' : 'AddNewInt', {
          area: localized('Organization').toLocaleLowerCase(),
        })}
      </h1>
      <Box sx={localStyles.inputLine}>
        <TextInput
          name={nameof<Organization>('name')}
          placeholder={localized('Name') + ' *'}
          validators={requiredValidator}
        />
      </Box>
      <Box sx={localStyles.inputLine}>
        <TextInput name={nameof<Organization>('description')} placeholder={localized('Description')} />
      </Box>
      <OrganizationDeleteButton existingOrganization={existingOrganization} />
      <StyledButton bottomStuck type="submit" disabled={pending}>
        {localizedInterpolation(existingOrganization ? 'UpdateInt' : 'SaveInt', {
          area: localized('Organization').toLocaleLowerCase(),
        })}
      </StyledButton>
      <SidebarCancelButton />
    </>
  );
});
